export const fmtNumber = (n) => {
  const r = Math.round(n * 1000) / 1000;
  return Object.is(r, -0) ? '0' : String(r);
};

export const fmtComplex = (c) => {
  if (Math.abs(c.im) < 1e-9) return fmtNumber(c.re);
  if (Math.abs(c.re) < 1e-9) return `${fmtNumber(c.im)}i`;
  return `${fmtNumber(c.re)} ${c.im >= 0 ? '+' : '−'} ${fmtNumber(Math.abs(c.im))}i`;
};
